import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import ArticleDetails from "../components/ArticleDetails02";

const ArticlePage = () => {
    return (
        <Layout pageTitle="苏州卫捷 | 文章详情">
            <NavOne />
            <PageHeader title="文章详情" />
            <ArticleDetails />
            <Footer />
        </Layout>
    );
};

export default ArticlePage;
